"use strict";

angular.module("informaApp")
    .service("PendoService", ["$window", "$cookies", "ConstantsSvc",
        function ($window, $cookies, ConstantsSvc) {

            var PRODUCT_NAME = "pharmapremia";

            function isPendoLoaded() {
                return typeof $window.pendo !== "undefined" &&
                       typeof $window.pendo.initialize === "function";
            }

            function getTokenFromCookie() {
                try {
                    var name = ConstantsSvc && ConstantsSvc.auth && ConstantsSvc.auth.tokenCookieName
                        ? ConstantsSvc.auth.tokenCookieName
                        : "token";
                    return $cookies.get(name) || null;
                } catch (e) {
                    return null;
                }
            }

            // UTF-8-safe JWT payload decoder. Returns null if token is malformed.
            function decodeToken(token) {
                if (!token || typeof token !== "string") { return null; }
                try {
                    var parts = token.split(".");
                    if (parts.length < 2) { return null; }

                    var base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
                    var pad = base64.length % 4;
                    if (pad) { base64 += new Array(5 - pad).join("="); }

                    var binary = $window.atob(base64);
                    var json = decodeURIComponent(binary.split("").map(function (c) {
                        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                    }).join(""));

                    return JSON.parse(json);
                } catch (e) {
                    return null;
                }
            }

            function normalizePendoEmail(email) {
                return (email || "").toLowerCase().replace(/\s+/g, "");
            }

            function getDomainName(email) {
                if (!email || email.indexOf("@") === -1) { return null; }
                var parts = email.split("@");
                return parts.length > 1 ? parts[1] : null;
            }

            function pickFirstSubscription(decodedToken) {
                var entls = decodedToken && decodedToken.entls;
                var sf = entls && entls.SF;
                if (!sf || !sf.pcds || !sf.pcds.length) { return {}; }
                return sf.pcds[0] || {};
            }

            function buildVisitorData(user, decodedToken) {
                var udt = (decodedToken && decodedToken.udt) || {};
                var uem = decodedToken && decodedToken.uem;
                var ut = decodedToken && decodedToken.ut;
                var entls = (decodedToken && decodedToken.entls) || {};
                var sf = entls.SF || {};
                var subscription = pickFirstSubscription(decodedToken);

                var rawEmail = uem || udt.em || (user && user.email);

                var fullName = "";
                if (udt.fn && udt.ln) {
                    fullName = udt.fn + " " + udt.ln;
                } else if (user && (user.firstName || user.lastName)) {
                    fullName = ((user.firstName || "") + " " + (user.lastName || "")).trim();
                }

                var visitor = {
                    id: normalizePendoEmail(rawEmail) || "user",
                    email: normalizePendoEmail(rawEmail),
                    full_name: fullName,
                    role: udt.jt || (user && user.federatedData_clientJobRole) || "user",
                    account_type: udt.ut || ut,
                    company: udt.cmp || (user && user.parentServiceAccountName),
                    product: PRODUCT_NAME,
                    snippetVersion: "v2.2",
                    last_visit_pharmapremia: new Date().toISOString(),
                    contact_id: sf.sfcid || (user && user.userId),
                    subscription_id: subscription.subid || (user && user.ParentServiceId),
                    product_id: subscription.subnm,
                    product_name: PRODUCT_NAME,
                    sub_product_name: (user && user.apn) || PRODUCT_NAME,
                    entitlement_type: subscription.atyp || (user && user.userEntitlementType) || "Free",
                    subscription_tier: subscription.ltyp || (user && user.userEntitlementType) || "",
                    login_type: udt.ut || ut
                };

                // Pendo guidance: omit empty values rather than send nulls
                Object.keys(visitor).forEach(function (key) {
                    var value = visitor[key];
                    if (value === null || value === undefined || value === "") {
                        delete visitor[key];
                    }
                });

                return visitor;
            }

            function buildAccountData(user, decodedToken) {
                var entls = (decodedToken && decodedToken.entls) || {};
                var sf = entls.SF || {};
                var email = user && user.email;

                var account = {
                    id: sf.cid || getDomainName(email) || PRODUCT_NAME,
                    name: sf.cnm || getDomainName(email) || PRODUCT_NAME,
                    salesforceAccountId: sf.cid,
                    company_type: "Company"
                };

                Object.keys(account).forEach(function (key) {
                    var value = account[key];
                    if (value === null || value === undefined || value === "") {
                        delete account[key];
                    }
                });

                return account;
            }

            return {
                initialize: function (user) {
                    if (!isPendoLoaded()) {
                        console.warn("PendoService: pendo.js not yet loaded — queued calls will replay when ready");
                    }

                    var token = getTokenFromCookie();
                    var decodedToken = decodeToken(token);

                    if (!decodedToken && !user) {
                        console.warn("PendoService: no JWT and no user — skipping initialize");
                        return;
                    }

                    var visitor = buildVisitorData(user, decodedToken);
                    if (!visitor || !visitor.id) {
                        console.warn("PendoService: visitor.id could not be derived — skipping initialize");
                        return;
                    }

                    $window.pendo.initialize({
                        visitor: visitor,
                        account: buildAccountData(user, decodedToken)
                    });
                },

                track: function (eventName, properties) {
                    if (!isPendoLoaded()) { return; }
                    $window.pendo.track(eventName, properties || {});
                },

                // Notify Pendo of an SPA route change so it can refresh page-level
                // analytics, guide targeting, and feature tagging for the new URL.
                pageLoad: function () {
                    if (!isPendoLoaded()) { return; }
                    if (typeof $window.pendo.pageLoad === "function") {
                        $window.pendo.pageLoad();
                    }
                },

                // Call on logout to clear visitor identity for the next session
                clearSession: function () {
                    if (!isPendoLoaded()) { return; }
                    if (typeof $window.pendo.clearSession === "function") {
                        $window.pendo.clearSession();
                    }
                }
            };
        }]);
